import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { colors } from "../../../theme/palette";

type EntityOverviewCardProps = {
  icon: React.ElementType;
  title: string;
  value: string;
  isTranslated?: boolean;
  isLoading: boolean;
};

const EntityOverviewCard = ({ icon: Icon, title, value, isTranslated, isLoading }: EntityOverviewCardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "6px",
        borderRadius: "20px",
        background: colors.Gray50,
        padding: "15px 0 15px",
        paddingInlineStart: "6px",
        minHeight: "75.5px",
        flex: 1,
      }}
    >
      <Box
        sx={{
          background: colors.Green100,
          borderRadius: "50%",
          width: "28px",
          height: "28px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading ? <Skeleton variant="circular" width="28px" height={28} /> : <Icon />}
      </Box>
      <Box>
        <Typography
          sx={{
            marginBottom: "5px",
            display: "block",
            fontWeight: "500",
            color: colors.Gray400,
            fontSize: "11px",
          }}
        >
          {isLoading ? <Skeleton variant="text" width="50px" /> : t(`pages.entity.${title}`)}
        </Typography>
        <Typography
          variant="body14Bold"
          sx={{
            fontWeight: 700,
            color: colors.Dark1000,
          }}
        >
          {isLoading ? (
            <Skeleton variant="text" width="35px" />
          ) : isTranslated ? (
            t(`pages.entity.${value}`)
          ) : (
            value || "N/A"
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default EntityOverviewCard;
